import { XMarkIcon } from '@heroicons/react/16/solid';
import { Button } from '../catalyst/button';
import { Field } from '../catalyst/fieldset';
import { Listbox, ListboxLabel, ListboxOption } from '../catalyst/listbox';

function getOptions(filter) {
  return filter.options.map((option) => {
    if (option.isGroup) {
      return (
        <div
          key={option.id}
          className="my-2"
        >
          <span className="mb-2 pl-4">{option.label}</span>
          {option.options.map((o, i) => (
            <ListboxOption
              key={`${o.value}_${i}`}
              value={o.value}
            >
              <ListboxLabel>{o.label}</ListboxLabel>
            </ListboxOption>
          ))}
        </div>
      );
    }

    return (
      <ListboxOption
        key={option.value}
        value={option.value}
      >
        <ListboxLabel>{option.label}</ListboxLabel>
      </ListboxOption>
    );
  });
}

export default function Filters(props) {
  const { filters = [] } = props;

  if (filters.length === 0) {
    return null;
  }

  return (
    <div className="flex gap-x-4">
      {filters.map((filter) => (
        <Field key={filter.id}>
          <div className="flex items-center">
            <Listbox
              className="w-48"
              name={filter.id}
              placeholder={filter.placeholder}
              onChange={filter.onSelectionChange}
              value={filter.value}
              disabled={filter.loading}
            >
              {getOptions(filter)}
            </Listbox>
            {filter.value && !filter.hideClear && (
              <Button
                plain
                onClick={filter.onClearClick}
                disabled={filter.loading}
              >
                Clear
                <XMarkIcon />
              </Button>
            )}
          </div>
        </Field>
      ))}
    </div>
  );
}
